<app-example-format
  [codeHtmlPath]="'code/examples/example-measure/example-measure-own-style-label/example-measure-own-style-label.component.html'"
  [codeScssPath]="'code/examples/example-measure/example-measure-own-style-label/example-measure-own-style-label.component.scss'"
  [codeTypescriptPath]="'code/examples/example-measure/example-measure-own-style-label/example-measure-own-style-label.component.ts'"
  [kaartConfigFilePath]="'code/examples/example-measure/example-measure-own-style-label/kaartconfig.json'"
  [title]="componentInfo.title"
  urlChangelog=""
  urlCodeHtml="example-draw/example-measure/example-measure-own-style-label/example-measure-own-style-label.component.html"
  urlCodeScss="example-draw/example-measure/example-measure-own-style-label/example-measure-own-style-label.component.scss"
  urlCodeTypescript="example-draw/example-measure/example-measure-own-style-label/example-measure-own-style-label.component.ts"
  urlGitHub=""
  urlKaartConfig="example-measure-own-style-label/kaartconfig.json"
  urlTSDocs=""
  urlTreeConfig=""
  urlVoorbeelden=""
>
  @if (componentInfo.tags && componentInfo.tags?.length > 0) {
    <div page-labels>
      @for (tag of componentInfo.tags; track tag) {
        <span class="badge bg-primary mx-1">{{ tag.toLocaleLowerCase() }}</span>
      }
    </div>
  }

  <div page-introduction>
    <p>{{ componentInfo.introduction }}</p>
    <p>
      In onderstaand voorbeeld zijn de tekst en de kleur van het label
      aangepast.
    </p>
  </div>

  <div page-functionality>
    <div class="row">
      <!-- DOCS:START functionality -->
      <div class="col-md-3 col-sm-6">
        <div>
          <b>Meten</b>
          <div class="d-flex flex-column align-items-stretch">
            <button [class.active]="measuring()" (click)="measureLine()">
              Lijn tekenen en meten
            </button>
            <hr />
            <button (click)="stopMeasureManual()">
              Tekenen en meten afronden
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-10">
        <div class="map-container">
          <ggc-map [webServices]="mapConfig" [minZoomlevel]="6"></ggc-map>
        </div>
      </div>
      <!-- DOCS:END functionality -->
    </div>
  </div>
</app-example-format>
